export interface CreateUniqueNameOptions {
  maxLength?: number
}

const DEFAULT_MAX_LENGTH = 100

export function createUniqueName(
  baseName: string,
  existingNames: string[],
  options: CreateUniqueNameOptions = {}
): string {
  const maxLength = options.maxLength ?? DEFAULT_MAX_LENGTH
  const existingLower = new Set(existingNames.map((name) => name.toLowerCase()))

  const truncate = (value: string): string => (value.length > maxLength ? value.slice(0, maxLength) : value)

  let candidate = truncate(baseName)
  let counter = 1

  while (existingLower.has(candidate.toLowerCase())) {
    const suffix = ` (${counter})`
    const headLength = Math.max(0, maxLength - suffix.length)
    candidate = `${baseName.slice(0, headLength)}${suffix}`
    counter += 1
  }

  return candidate
}
